import { Injectable } from '@angular/core';
import { apiUrl } from '../schema/api-url';
import { BaseService } from './master/base.service';
import { APIService } from './master/api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from './master/authentication.service';
@Injectable({
  providedIn: 'root',
})

export class RegionService extends BaseService {

  constructor(private _apiService: APIService, 
    private authenticationService: AuthenticationService,
    private http: HttpClient) {
    super(_apiService);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Tìm kiếm tỉnh thành trong danh sách
   */
  timKiemTinh(requestBody) {
    return super.post(apiUrl.diaPhuong.danhSachTinh, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Thêm mới tỉnh thành
   */
  themMoiTinh(requestBody) {
    return super.post(apiUrl.diaPhuong.themMoiTinh, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param requestBody
   * @description Cập nhật thông tin tỉnh thành
   */
  capNhatTinh(requestBody) {
    return super.put(apiUrl.diaPhuong.capNhatTinh, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method DELETE
   * @param MaTinhThanhBHXH
   * @description Xoá thông tin tỉnh thành
   */
  xoaTinh(MaTinhThanhBHXH) {
    return super.delete(apiUrl.diaPhuong.xoaTinh, { MaTinhThanhBHXH : MaTinhThanhBHXH });
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param MaTinhThanhBHXH
   * @description Khôi phục thông tin tỉnh thành
   */
  khoiPhucTinh(MaTinhThanhBHXH) {
    return super.put(apiUrl.diaPhuong.khoiPhucTinh + MaTinhThanhBHXH);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Tìm kiếm quận huyện trong danh sách
   */
  timKiemHuyen(requestBody) {
    return super.post(apiUrl.diaPhuong.timKiemHuyen, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Thêm mới quận huyện
   */
  themMoiHuyen(requestBody) {
    return super.post(apiUrl.diaPhuong.themMoiHuyen, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param requestBody
   * @description Cập nhật thông tin quận huyện
   */
  capNhatHuyen(requestBody) {
    return super.put(apiUrl.diaPhuong.capNhatHuyen, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method DELETE
   * @param maQuanHuyenBHXH
   * @description Xoá thông tin quận huyện
   */
  xoaHuyen(maQuanHuyenBHXH) {
    return super.delete(apiUrl.diaPhuong.xoaHuyen, { maQuanHuyenBHXH: maQuanHuyenBHXH });
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param maQuanHuyenBHXH
   * @description Khôi phục thông tin quận huyện
   */
  khoiPhucHuyen(maQuanHuyenBHXH) {
    return super.put(apiUrl.diaPhuong.khoiPhucHuyen + maQuanHuyenBHXH);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Tìm kiếm xã phường trong danh sách
   */
  timKiemXa(requestBody) {
    return super.post(apiUrl.diaPhuong.timKiemXa, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Thêm mới xã phường
   */
  themMoiXa(requestBody) {
    return super.post(apiUrl.diaPhuong.themMoiXa, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param requestBody
   * @description Cập nhật thông tin xã phường
   */
  capNhatXa(requestBody) {
    return super.put(apiUrl.diaPhuong.capNhatXa, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method DELETE
   * @param maTinhThanhBHXH
   * @description Xoá thông tin xã phường
   */
  xoaXa(maXaBHXH) {
    return super.delete(apiUrl.diaPhuong.xoaXa, { maXaBHXH: maXaBHXH });
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param maXaBHXH
   * @description Khôi phục thông tin xã phường
   */
  khoiPhucXa(maXaBHXH) {
    return super.put(apiUrl.diaPhuong.khoiPhucXa + maXaBHXH);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Tìm kiếm dân tộc trong danh sách
   */
  timKiemDanToc(requestBody) {
    return super.post(apiUrl.danhMuc.timKiemDanToc, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Thêm mới dân tộc
   */
  themMoiDanToc(requestBody) {
    return super.post(apiUrl.danhMuc.themMoiDanToc, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param requestBody
   * @description Cập nhật thông tin dân tộc
   */
  capNhatDanToc(requestBody) {
    return super.put(apiUrl.danhMuc.capNhatDanToc, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method DELETE
   * @param idDanToc
   * @description Xoá thông tin dân tộc
   */
  xoaDanToc(idDanToc) {
    return super.delete(apiUrl.danhMuc.xoaDanToc, { idDanToc: idDanToc });
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param idDanToc
   * @description Khôi phục thông tin dân tộc
   */
  khoiPhucDanToc(idDanToc) {
    return super.put(apiUrl.danhMuc.khoiPhucDanToc, { idDanToc: idDanToc });
  }

  getTinh() {
    return super.get(apiUrl.diaPhuong.tinhURL);
  }
  getTinhadd() {
    return super.get(apiUrl.diaPhuong.tinhURL);
  }

  getTinhLogin() {
    return this.http.get(apiUrl.diaPhuong.tinhPublic);
  }

  getHuyen(maTinh) {
    return super.get(apiUrl.diaPhuong.huyenURL, { maTinh: maTinh });
  }

  getXa(maTinh) {
    return super.get(apiUrl.diaPhuong.xaURL, { maTinh: maTinh });
  }

  getThon(maTinh, maXa) {
    return super.get(apiUrl.diaPhuong.thonURL, { maTinh: maTinh, maXa: maXa });
  }
  getHuyenadd(maTinhadd) {
    return super.get(apiUrl.diaPhuong.huyenURL, { maTinhadd: maTinhadd });
  }

  getXaadd(maTinhadd, maHuyenadd) {
    return super.get(apiUrl.diaPhuong.xaURL, { maTinhadd: maTinhadd, maHuyenadd: maHuyenadd });
  }

  getThonadd(maTinhadd, maHuyenadd, maXaadd) {
    return super.get(apiUrl.diaPhuong.thonURL, { maTinhadd: maTinhadd, maHuyenadd: maHuyenadd, maXaadd: maXaadd });
  }
  getListThon(requestBody) {
    return super.post(apiUrl.diaPhuong.getAllRegionUrl, requestBody);
  }

  addNewVillage(requestBody) {
    return super.post(apiUrl.diaPhuong.addVillageUrl, requestBody);
  }

  updateVillage(requestBody) {
    return super.put(apiUrl.diaPhuong.updateVillageUrl, requestBody);
  }

  removeVillage(maThon) {
    return super.delete(apiUrl.diaPhuong.removeVillageUrl, { maThon: maThon });
  }

  recoverVillage(maThon) {
    return super.get(apiUrl.diaPhuong.recoverVillageUrl, { maThon: maThon });
  }

  searchLogs(params: {
    blurry?: string;
    logType?: string;
    createTime?: string[];
    page?: number;
    size?: number;
  } ): Observable<any> {
    return this._apiService.get(
      apiUrl.danhMuc.SYS_LOG.nhatKyHeThong,
      {
        ...params,
        sort:'id,desc'
      } 
    );
  }

  errorStackTrace(id:string):Observable<{exception:string}>{
    return this._apiService.get(
      apiUrl.danhMuc.SYS_LOG.getStackTraceDetail+`/${id}`
    )
  }

  downloadLogs(params: {
    blurry?: string;
    logType?: string;
    createTime?: string[];
  }): Observable<any> {
    return this.http.get(
      apiUrl.danhMuc.SYS_LOG.taiNhatKyHeThong,
      {
        params: params,
        responseType: 'blob',
        observe: 'body',
        headers:{
          Authorization: 'Bearer ' + this.authenticationService.getToken(),
          'Content-Type': 'application/json',
        }
      }
    );
  }


}
